import React from "react";
import { Row, Col, Card, CardHeader, CardBody, Button } from "reactstrap";

const ProductViewWithQR = ({ product, closeModal }) => {
  // Generate download URL from base64
  const qrDataUrl = product?.productQRCodebase64
    ? `data:image/png;base64,${product?.productQRCodebase64}`
    : null;

  return (
    <Row>
      <Col xl="12">
        <Card className="bg-secondary shadow">
          <CardHeader className="bg-white border-0">
            <Row className="align-items-center">
              <Col xs="8">
                <h3 className="mb-0">View Product</h3>
              </Col>
              <Col className="text-right" xs="4">
                <Button
                  color="primary"
                  onClick={closeModal}
                  size="sm"
                  close
                  style={{ cursor: "pointer", fontSize: "25px" }}
                />
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <Row>
              <Col md="6">
                <p>
                  <strong>Product Name:</strong> {product?.productName}
                </p>
                <p>
                  <strong>Category:</strong> {product?.categoryName} (
                  {product?.categoryCode})
                </p>
                <p>
                  <strong>Subcategory:</strong> {product?.subCategoryName} (
                  {product?.subCategoryCode})
                </p>
                <p>
                  <strong>Trade Unit:</strong> {product?.tradeUnit}
                </p>
                <p>
                  <strong>Unit Cost:</strong> {product?.unitCost}
                </p>
                <p>
                  <strong>Unit Price:</strong> {product?.unitPrice}
                </p>
                <p>
                  <strong>Unique Code:</strong> {product?.productUniqueCode}
                </p>
              </Col>
              <Col
                md="6"
                className="d-flex flex-column justify-content-center align-items-center"
              >
                {qrDataUrl ? (
                  <>
                    <img
                      src={qrDataUrl}
                      alt="Product QR Code"
                      style={{ maxWidth: "250px", maxHeight: "250px" }}
                    />
                    <a
                      href={qrDataUrl}
                      download={`${product?.productName || "qr-code"}.png`}
                      className="btn btn-success mt-3"
                    >
                      Download QR Code
                    </a>
                  </>
                ) : (
                  <p>No QR Code available</p>
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default ProductViewWithQR;
